<template>
    <div id="map" class="map"/>
</template>

<script setup lang="ts">

import {onMounted} from 'vue';
import {useMap} from '../../compositions';
import { Merchant } from '../../types';

const props = defineProps<{merchant: Merchant}>();
const {loadMap, redirectToDirections} = useMap();

onMounted(() => {
    loadMap(props.merchant);
});

const getDirectionsTo = ((lat: number, long: number, destination: string) => {
    redirectToDirections(lat, long, destination, props.merchant.businessName);
});

defineExpose({
    getDirectionsTo,
});

</script>

<style scoped>
.map {
    height: 17.1875rem;
    width: 100%;
}
</style>
